/** Alinhado a `Baruk.Know.InDoc.Domain.Enums` — aceita número ou string (JsonStringEnumConverter na API). */
export const SignatureRequestStatusCode = {
  Pending: 0,
  InProgress: 1,
  Completed: 2,
  Cancelled: 3,
} as const;

export const SignatureStatusCode = {
  Pending: 0,
  Signed: 1,
  Rejected: 2,
} as const;

export const SignatureRuleCode = {
  All: 0,
  Any: 1,
} as const;

export const SignatureTypeCode = {
  Certificate: 0,
  Electronic: 1,
  Handwritten: 2,
} as const;

function normalizeEnumValue(
  value: unknown,
  nameToCode: Record<string, number>
): number {
  if (typeof value === 'number' && !Number.isNaN(value))
  {
    return value;
  }

  if (typeof value === 'string')
  {
    const key = value.trim().toLowerCase();
    if (key in nameToCode)
    {
      return nameToCode[key];
    }

    const asNum = Number(value);
    if (!Number.isNaN(asNum))
    {
      return asNum;
    }
  }

  return Number(value) || 0;
}

const signatureRequestStatusByName: Record<string, number> = {
  pending: SignatureRequestStatusCode.Pending,
  inprogress: SignatureRequestStatusCode.InProgress,
  completed: SignatureRequestStatusCode.Completed,
  cancelled: SignatureRequestStatusCode.Cancelled,
  '0': SignatureRequestStatusCode.Pending,
  '1': SignatureRequestStatusCode.InProgress,
  '2': SignatureRequestStatusCode.Completed,
  '3': SignatureRequestStatusCode.Cancelled,
};

const signatureStatusByName: Record<string, number> = {
  pending: SignatureStatusCode.Pending,
  signed: SignatureStatusCode.Signed,
  rejected: SignatureStatusCode.Rejected,
  '0': SignatureStatusCode.Pending,
  '1': SignatureStatusCode.Signed,
  '2': SignatureStatusCode.Rejected,
};

const signatureRuleByName: Record<string, number> = {
  all: SignatureRuleCode.All,
  any: SignatureRuleCode.Any,
  '0': SignatureRuleCode.All,
  '1': SignatureRuleCode.Any,
};

const signatureTypeByName: Record<string, number> = {
  certificate: SignatureTypeCode.Certificate,
  electronic: SignatureTypeCode.Electronic,
  handwritten: SignatureTypeCode.Handwritten,
  '0': SignatureTypeCode.Certificate,
  '1': SignatureTypeCode.Electronic,
  '2': SignatureTypeCode.Handwritten,
};

export function normalizeSignatureRequestStatus(status: unknown): number {
  return normalizeEnumValue(status, signatureRequestStatusByName);
}

export function normalizeSignatureStatus(status: unknown): number {
  return normalizeEnumValue(status, signatureStatusByName);
}

export function normalizeSignatureRule(rule: unknown): number {
  return normalizeEnumValue(rule, signatureRuleByName);
}

export function normalizeSignatureType(type: unknown): number {
  return normalizeEnumValue(type, signatureTypeByName);
}

export function isPendingSignatureRequestStatus(status: unknown): boolean {
  return normalizeSignatureRequestStatus(status) === SignatureRequestStatusCode.Pending;
}

export function isInProgressSignatureRequestStatus(status: unknown): boolean {
  return normalizeSignatureRequestStatus(status) === SignatureRequestStatusCode.InProgress;
}

export function isCompletedSignatureRequestStatus(status: unknown): boolean {
  return normalizeSignatureRequestStatus(status) === SignatureRequestStatusCode.Completed;
}

export function isCancelledSignatureRequestStatus(status: unknown): boolean {
  return normalizeSignatureRequestStatus(status) === SignatureRequestStatusCode.Cancelled;
}

export function isSignerSigned(status: unknown): boolean {
  return normalizeSignatureStatus(status) === SignatureStatusCode.Signed;
}

export function isSignerRejected(status: unknown): boolean {
  return normalizeSignatureStatus(status) === SignatureStatusCode.Rejected;
}

export function signerStatusMeansDone(status: unknown): boolean {
  return isSignerSigned(status) || isSignerRejected(status);
}
